/** @format */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    ArchiveStatus,
    CommonSearchFilters,
    DeliveryStatus,
    ExternalSignatureRequestStatus,
    LocalDateRange,
    SearchParameters,
    SearchResult,
    SignatureRequestSearchResultItem,
} from 'common-typescript/types';
import { Observable } from 'rxjs';
import { dateRangeAllowBlankDateToQueryParam, simpleObjectToQueryParams } from '../search-ng/search-utils';

export interface SignatureRequestQueryParams extends CommonSearchFilters {
    externalSignatureRequestStatuses?: ExternalSignatureRequestStatus[];
    deliveryStatuses?: DeliveryStatus[];
    archiveStatuses?: ArchiveStatus[];
    dateRange?: LocalDateRange;
}
const CONFIG = {
    backend: '/seppo/api',
    search() {
        return `${this.backend}/signature-request/search`;
    },
};
@Injectable({
    providedIn: 'root',
})
export class SignatureRequestSearchService {
    constructor(private httpClient: HttpClient) {}

    searchSignatureRequests(
        searchParams: SearchParameters<SignatureRequestQueryParams>,
    ): Observable<SearchResult<SignatureRequestSearchResultItem>> {
        const params = simpleObjectToQueryParams({
            ...searchParams.filters,
            ...searchParams.options,
            dateRange: dateRangeAllowBlankDateToQueryParam(searchParams.filters.dateRange),
        });

        return this.httpClient.get<SearchResult<SignatureRequestSearchResultItem>>(CONFIG.search(), {
            params,
        });
    }
}
